import { BaseApi } from './baseApi';
export default class SchemaPresetApi extends BaseApi {
    getSchemaPreset(id) {
        return this.apiCall({
            method: 'GET',
            route: `schema-preset/${id}`,
        });
    }
    listSchemaPresets(params = {}) {
        return this.apiCall({
            method: 'GET',
            route: 'schema-preset',
            params,
        });
    }
    updateSchemaPreset(id, data) {
        return this.apiCall({
            method: 'PATCH',
            route: `schema-preset/${id}`,
            data,
        });
    }
    deleteSchemaPreset(id) {
        return this.apiCall({
            method: 'DELETE',
            route: `schema-preset/${id}`,
        });
    }
    createSchemaPreset(data) {
        return this.apiCall({
            method: 'POST',
            route: 'schema-preset',
            data,
        });
    }
}
//# sourceMappingURL=schemaPresetApi.js.map